import script from "./TeacherLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherLayout.vue?vue&type=script&setup=true&lang=js"

import "./TeacherLayout.vue?vue&type=style&index=0&id=e7ee1166&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7ee1166"]])

export default __exports__